// extracted by mini-css-extract-plugin
export default {"dimmer":"styles__dimmer--30SM2"};